import { useNavigate } from "react-router-dom";
import ui from "./ui.module.css";

// Goes back to the previous page (keeping its tabs/filters), or to
// `fallback` when the page was opened directly.
const BackLink = ({ fallback, label = "Back" }) => {
  const navigate = useNavigate();
  const canGoBack = window.history.state?.idx > 0;

  return (
    <button
      type="button"
      className={ui.backLink}
      onClick={() => (canGoBack ? navigate(-1) : navigate(fallback))}
    >
      <i className="bi bi-arrow-left me-1"></i>
      {label}
    </button>
  );
};

export default BackLink;
